import {
    Box,
    Button,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Popover,
    styled,
    Tab,
    Tabs,
    Typography
} from "@mui/material";

export const ListRewardsWrapper = styled(Box)({
    "& .MuiTab-root": {
        fontSize: 24,
        fontWeight: 700,
        color: "#D4D4D4",
        "&.Mui-selected": {
            "& .dot": {
                backgroundColor: "#EF5B1B"
            }
        }
    },
    "& .MuiTabs-indicator": {
        display: "none"
    },
    "& .dot": {
        height: 20,
        width: 23,
        backgroundColor: "#D4D4D4",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontSize: 12
    }
});

export const VoucherWrapper = styled(Box)({
    display: "flex",
    height: 130,
    "&.testTicket": {
        boxShadow: " 0px 0px 4px rgba(0, 0, 0, 0.2)",
        borderRadius: "10px",
        position: "relative",
        "& img": {
            width: "100%",
            height: "100%",
        },
        "& .ticket-divider": {
            position: "absolute",
            left: 122,
            width: 16,
            height: "100%",
            "& .divider-border": {
                "&:after": {
                    "content": "''",
                    position: "absolute",
                    height: "100%",
                    borderRight: "1px dashed #D9D9D9",
                    left: 8,
                },
            },
            "& .notch": {
                position: "absolute",
                width: 16,
                height: 16,
                overflow: "hidden",
                top: -2,
                "&:after": {
                    "content": "''",
                    position: "relative",
                    display: "block",
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    top: "-50%",
                    boxShadow: "inset 0 2px 4px rgba(41, 54, 61, 0.25)",
                    backgroundColor: "#fff"
                },
                "&.bottom": {
                    bottom: -2,
                    top: "unset",
                    "&:after": {
                        top: "unset",
                        bottom: "-50%",
                        boxShadow: "inset 0 -2px 4px rgba(41, 54, 61, 0.25)"
                    }
                }
            }
        },
        "& .ticket": {
            position: "relative",
            overflow: "hidden",
            padding: "25px 12px 25px 20px",
            "&.firstPart": {
                width: 122,
                padding: "8px 0px 8px 8px",
            },
            "&.secondPart": {
                width: "calc(100% - 122px)"
            },
        }
    },
    "& .subCampaignTitle": {
        overflow: "hidden",
        display: "-webkit-box",
        "-webkit-line-clamp": "2",
        "-webkit-box-orient": "vertical",
    }
});

export const ViewMoreBtn = styled(Button)({
    backgroundColor: "rgba(17, 85, 170, 0.1)",
    color: "#1155AA",
    fontSize: 14,
    height: 48,
    "&:hover": {
        backgroundColor: "rgba(17, 85, 170, 0.1)",
    }
});

export const ExpiredDate = styled(Typography)({
    fontSize: 12,
    fontWeight: 500,
});

export const ListWrapper = styled(List)({
    fontSize: 12,
    "& .MuiListItemIcon-root": {
        minWidth: 35,
    },
    "& .MuiListItemText-inset": {
        paddingLeft: 35
    },
    "& .MuiListItemButton-root": {
        paddingTop: 0,
        paddingBottom: 0,
        "& .active": {
            "& span": {
                fontWeight: 600
            }
        }
    }
});
